export enum ExternalChatResponseError {
  cannotCreateConversation = 'cannotCreateConversation',
  notConfigured = 'notConfigured',
  serviceClosed = 'serviceClosed',
}
